import styled from "styled-components";

interface EquipMonitorStyleProps {
  $gridColumn?: number;
}

export const EquipMonitoringBox = styled.div`
  display: grid;
  height: calc(100vh - 128px);
  grid-template-columns: repeat(3, 1fr);
  flex-grow: 1;
  gap: 16px;
`;

export const EquipMonitorList = styled.ul<EquipMonitorStyleProps>`
  display: grid;
  height: 100%;
  grid-template-rows: repeat(
    ${(props) => (props.$gridColumn ? props.$gridColumn : 1)},
    1fr
  );
  gap: 16px;
`;
